<template>
  <div>
    <document-placeholders
      :form="form"
      :incident="incident"
      :type="documentType?.identifier || ''"
    ></document-placeholders>

    <fieldset>
      <legend>Reasons For Hire</legend>

      <fieldset class="mt-3">
        <legend>Commuting</legend>
        <div class="col-12">
          <label class="control-label">
            TRAVELLING TO AND FROM WORK
          </label>
          <toggleswitch
            :labels="true"
            name="travelling_to_and_from_work"
            :stack="true"
            labelColumn="col-8"
            inputColumn="col-4"
            v-model="form.travelling_to_and_from_work"
            :disabled="isReadonly()"
          ></toggleswitch>

          <div class="row" v-if="form.travelling_to_and_from_work">
            <div class="col-lg-4">
              <label class="control-label">
                Distance to workplace each way
              </label>
              <input
                v-model="form.distance_to_workplace"
                name="distance_to_workplace"
                class="form-control"
                :disabled="isReadonly()"
              />
            </div>

            <div class="col-lg-4">
              <label class="control-label">
                How often is the commute to the workplace
              </label>
              <input
                v-model="form.commute_frequency"
                name="commute_frequency"
                class="form-control"
                :disabled="isReadonly()"
              />
            </div>

            <div class="col-lg-4">
              <label class="control-label">
                Shift pattern
              </label>
              <input
                v-model="form.shift_pattern"
                name="shift_pattern"
                class="form-control"
                :disabled="isReadonly()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="mt-3">
        <legend>SDP</legend>
        <div class="row">
          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="gym_fitness_sports_club"
              label="GYM/FITNESS/SPORTS CLUB"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.gym_fitness_sports_club"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="visiting_family"
              label="VISITING FAMILY"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.visiting_family"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="part_of_bike_club"
              label="PART OF A BIKE CLUB THAT MEET"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.part_of_bike_club"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="job_interviews"
              label="JOB INTERVIEWS"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.job_interviews"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="visiting_friends"
              label="VISITING FRIENDS"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.visiting_friends"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="weekend_hobby"
              label="WEEKEND HOBBY"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.weekend_hobby"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="medical_appointments"
              label="MEDICAL APPOINTMENTS"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.medical_appointments"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="shopping"
              label="SHOPPING"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.shopping"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="caring_for_elderly_or_vulnerable"
              label="CARING FOR AN ELDERLY OR VULNERABLE PERSON"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.caring_for_elderly_or_vulnerable"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>
        </div>
      </fieldset>

      <fieldset class="mt-3">
        <legend>If access to an alternative car/bike is unsuitable</legend>
        <div class="row">
          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="shared_car_with_family"
              label="SHARED CAR WITH FAMILY"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.shared_car_with_family"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="fuel_costs"
              label="FUEL COSTS"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.fuel_costs"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="other_bike_for_different_use"
              label="OTHER BIKE IS FOR A DIFFERENT USE (sports/leisure/show bike)"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.other_bike_for_different_use"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="off_road"
              label="OFF ROAD (No MOT/TAX/Insurance/Unroadworthy)"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.off_road"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="parking"
              label="PARKING"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.parking"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="travel_time"
              label="TRAVEL TIME"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.travel_time"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="restricted_mileage"
              label="RESTRICTED MILEAGE"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.restricted_mileage"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>
        </div>
      </fieldset>

      <fieldset class="mt-3">
        <legend>Business Use</legend>
        <div class="row">
          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="commuting_for_business_use"
              label="COMMUTING FOR BUSINESS USE"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.commuting_for_business_use"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="delivery_driver"
              label="DELIVERY DRIVER"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.delivery_driver"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>

          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              name="food_delivery_driver"
              label="FOOD DELIVERY DRIVER"
              labelColumn="col-8"
              inputColumn="col-4"
              v-model="form.food_delivery_driver"
              :disabled="isReadonly()"
            ></toggleswitch>
          </div>
        </div>
      </fieldset>
    </fieldset>

    <hr />

    <div class="col-12">
      <label class="control-label">
        Require Same Vehicle
      </label>
      <toggleswitch
        :labels="true"
        name="require_same_vehicle"
        :stack="true"
        helper="So based on this you would require the same from an accident replacement vehicle?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.require_same_vehicle"
        :disabled="isReadonly()"
      ></toggleswitch>

      <label class="control-label">
        Additional Insurance Premium Required
      </label>
      <toggleswitch
        :labels="true"
        name="additional_insurance_premium_required"
        :stack="true"
        helper="Is an additional insurance premium required for this hire?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.additional_insurance_premium_required"
        :disabled="isReadonly()"
      ></toggleswitch>

      <template v-if="form.additional_insurance_premium_required">
        <label class="control-label">
          License Less Than
        </label>

        <input
          v-model="form.license_less_than"
          name="license_less_than"
          class="form-control"
          :disabled="isReadonly()"
        />
      </template>

      <label class="control-label">
        Third Party Offered Services To Our Client?
      </label>
      <toggleswitch
        :labels="true"
        name="tp_offered_services"
        :stack="true"
        helper="Did the third party offer services to our client?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.tp_offered_services"
        :disabled="isReadonly()"
      ></toggleswitch>

      <template v-if="form.tp_offered_services">
        <label class="control-label">
          Why Didn't The Client Accept The Offer Of Services?
        </label>

        <input
          v-model="form.reasons_hire_vehicle_is_required"
          name="reasons_hire_vehicle_is_required"
          class="form-control"
          :disabled="isReadonly()"
        />
      </template>

      <label class="control-label">
        Are you the primary income earner in your household?
      </label>
      <toggleswitch
        :labels="true"
        name="primary_income_earner"
        :stack="true"
        helper="Is the client the primary income earner in their household?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.primary_income_earner"
        disabled="isReadonly()"
      ></toggleswitch>

      <label class="control-label">
        Non-Standard Driver?
      </label>
      <toggleswitch
        :labels="true"
        name="non_standard_driver"
        :stack="true"
        helper="Are any of the drivers non-standard drivers?"
        labelColumn="col-8"
        inputColumn="col-4"
        v-model="form.non_standard_driver"
        :disabled="isReadonly()"
      ></toggleswitch>

      <template v-if="form.non_standard_driver">
        <label class="control-label">
          Under 25 or Over 70?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_age"
          :stack="true"
          helper="Are any of the riders under 25 or over 70?"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_age"
          :disabled="isReadonly()"
        ></toggleswitch>

        <label class="control-label">
          Non-Standard Occupation?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_occupation"
          :stack="true"
          helper="Are any of the riders in the following groups: Professional – Sportsmen/Women, Actors, Entertainers, Gamblers and Musicians, Publicans, Journalists?"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_occupation"
          :disabled="isReadonly()"
        ></toggleswitch>

        <label class="control-label">
          License Less Than 12 Months Old?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_license_age"
          helper="Do any of the riders have a license that is less than 12 months old?"
          :stack="true"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_license_age"
          :disabled="isReadonly()"
        ></toggleswitch>

        <label class="control-label">
          Has Convictions/Points?
        </label>
        <toggleswitch
          :labels="true"
          name="non_standard_convictions"
          :stack="true"
          helper="Do any of the riders have convictions resulting in an unspent ban or 7 or more outstanding points in the last 4 years?"
          labelColumn="col-8"
          inputColumn="col-4"
          v-model="form.non_standard_convictions"
          :disabled="isReadonly()"
        ></toggleswitch>
      </template>
    </div>
  </div>
</template>
<script>
import DocumentPlaceholders from '@/components/Modules/Shared/Children/GenerateDocument/DocumentPlaceholders';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    documentTypes: {
      type: Array,
      required: true
    }
  },

  components: {
    DocumentPlaceholders
  },

  data() {
    return {
      documentType: null
    };
  },

  methods: {},

  watch: {
    documentTypes: {
      handler(types) {
        this.documentType = types.find(
          type => type.name === 'mitigation_statement'
        );
      },
      immediate: true
    }
  }
};
</script>
